(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-mosaic-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGifVideos(scope) {
      (scope || document).querySelectorAll('.cmh [data-mmc-video-gif]').forEach(function (wrap) {
        if (wrap.dataset.mmcGifInit === '1') return;
        wrap.dataset.mmcGifInit = '1';
        var video = wrap.querySelector('video');
        var btn = wrap.querySelector('[data-mmc-play-btn]');
        if (!video) return;
        function setPlaying(playing) {
          wrap.classList.toggle('is-playing', playing);
          if (btn) btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        }
        function togglePlay() {
          if (video.paused) {
            video.muted = true;
            video.play().then(function () { setPlaying(true); }).catch(function () {});
          } else {
            video.pause();
            setPlaying(false);
          }
        }
        wrap.addEventListener('click', function (e) {
          if (e.target.closest('[data-mmc-play-btn]') || !wrap.classList.contains('is-playing')) {
            e.preventDefault();
            togglePlay();
          }
        });
        if (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            togglePlay();
          });
        }
        video.addEventListener('ended', function () {
          if (video.loop) return;
          setPlaying(false);
        });
        video.addEventListener('pause', function () {
          if (!video.ended) setPlaying(false);
        });
      });
    }

    function boot(scope) {
      initGifVideos(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diy-kit-multislider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGifVideos(scope) {
      (scope || document).querySelectorAll('.section-diy-kit-multislider [data-mmc-video-gif]').forEach(function (wrap) {
        if (wrap.dataset.mmcGifInit === '1') return;
        wrap.dataset.mmcGifInit = '1';
        var video = wrap.querySelector('video');
        var btn = wrap.querySelector('[data-mmc-play-btn]');
        if (!video) return;
        if (btn) btn.setAttribute('aria-pressed', 'false');
        function setPlaying(playing) {
          wrap.classList.toggle('is-playing', playing);
          if (btn) btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        }
        function togglePlay() {
          if (video.paused) {
            video.muted = true;
            video.play().then(function () { setPlaying(true); }).catch(function () {
              setPlaying(false);
            });
          } else {
            video.pause();
            setPlaying(false);
          }
        }
        wrap.addEventListener('click', function (e) {
          if (e.target.closest('[data-mmc-play-btn]') || !wrap.classList.contains('is-playing')) {
            e.preventDefault();
            togglePlay();
          }
        });
        video.addEventListener('ended', function () {
          if (video.loop) return;
          setPlaying(false);
        });
        video.addEventListener('pause', function () {
          if (!video.ended) setPlaying(false);
        });
      });
    }

    function initSideCarouselVideos(scope) {
      (scope || document).querySelectorAll('.section-diy-kit-multislider .mmm-side-carousel [data-amc-track]').forEach(function (track) {
        if (track.dataset.mmmSideVideoInit === '1') return;
        track.dataset.mmmSideVideoInit = '1';

        function playVideo(video) {
          if (!video) return;
          video.muted = true;
          video.setAttribute('playsinline', '');
          video.playsInline = true;
          var tryPlay = function () {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          };
          if (video.readyState >= 2) {
            tryPlay();
          } else {
            video.addEventListener('loadeddata', tryPlay, { once: true });
            try {
              video.load();
            } catch (e) {}
          }
        }

        function syncVideos() {
          var trackRect = track.getBoundingClientRect();
          if (trackRect.width < 1 || trackRect.height < 1) return;
          track.querySelectorAll('[data-amc-slide]').forEach(function (slide) {
            var rect = slide.getBoundingClientRect();
            var visible =
              rect.width > 0 &&
              rect.right > trackRect.left + 2 &&
              rect.left < trackRect.right - 2;
            slide.querySelectorAll('video.mmc-media--plain').forEach(function (video) {
              if (visible) {
                playVideo(video);
              } else {
                video.pause();
              }
            });
          });
        }

        /* Keep parent mosaic scroller from stealing horizontal swipes on side carousels */
        ['touchstart', 'touchmove'].forEach(function (evt) {
          track.addEventListener(
            evt,
            function (e) {
              e.stopPropagation();
            },
            { passive: true }
          );
        });

        var scrollTimer;
        track.addEventListener('scroll', function () {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(syncVideos, 80);
        });
        window.addEventListener('resize', syncVideos);
        if (typeof IntersectionObserver !== 'undefined') {
          var io = new IntersectionObserver(function () { syncVideos(); }, { threshold: 0.2 });
          io.observe(track);
        }
        syncVideos();
        window.setTimeout(syncVideos, 250);
        window.setTimeout(syncVideos, 1000);
      });
    }

    function boot(scope) {
      initGifVideos(scope);
      initSideCarouselVideos(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multislider-mosaic-for-mobile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGifVideos(scope) {
      (scope || document).querySelectorAll('[data-mmc-video-gif]').forEach(function (wrap) {
        if (wrap.dataset.mmcGifInit === '1') return;
        wrap.dataset.mmcGifInit = '1';
        var video = wrap.querySelector('video');
        var btn = wrap.querySelector('[data-mmc-play-btn]');
        if (!video) return;
        function setPlaying(playing) {
          wrap.classList.toggle('is-playing', playing);
          if (btn) btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        }
        function togglePlay() {
          if (video.paused) {
            video.muted = true;
            video.play().then(function () { setPlaying(true); }).catch(function () {});
          } else {
            video.pause();
            setPlaying(false);
          }
        }
        wrap.addEventListener('click', function (e) {
          if (e.target.closest('[data-mmc-play-btn]') || !wrap.classList.contains('is-playing')) {
            e.preventDefault();
            togglePlay();
          }
        });
        if (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            togglePlay();
          });
        }
        video.addEventListener('ended', function () {
          if (video.loop) return;
          setPlaying(false);
        });
        video.addEventListener('pause', function () {
          if (!video.ended) setPlaying(false);
        });
      });
    }

    function getSlideIndex(track, slides) {
      var scroll = track.scrollLeft;
      var index = 0;
      var best = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dist = Math.abs(slides[i].offsetLeft - scroll);
        if (dist < best) {
          best = dist;
          index = i;
        }
      }
      return index;
    }

    function scrollToSlide(track, slides, index, behavior) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
    }

    function updateDots(root, index) {
      var dotsWrap = root.querySelector('[data-amc-dots]');
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('[data-amc-dot]').forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function initMmmCarouselNav(scope) {
      (scope || document).querySelectorAll('[data-mmm-carousel]').forEach(function (root) {
        if (root.dataset.mmmNavInit === '1') return;
        root.dataset.mmmNavInit = '1';
        var track = root.querySelector('[data-amc-track]');
        if (!track) return;
        function slides() {
          return track.querySelectorAll('[data-amc-slide]');
        }
        function go(delta) {
          var list = slides();
          if (!list.length) return;
          var current = getSlideIndex(track, list);
          var next = (current + delta + list.length) % list.length;
          scrollToSlide(track, list, next);
          updateDots(root, next);
        }
        root.querySelectorAll('[data-mmm-carousel-prev]').forEach(function (btn) {
          btn.addEventListener('click', function () { go(-1); });
        });
        root.querySelectorAll('[data-mmm-carousel-next]').forEach(function (btn) {
          btn.addEventListener('click', function () { go(1); });
        });
        var scrollTimer;
        track.addEventListener('scroll', function () {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(function () {
            var list = slides();
            if (!list.length) return;
            updateDots(root, getSlideIndex(track, list));
          }, 80);
        });
        var dotsWrap = root.querySelector('[data-amc-dots]');
        if (dotsWrap) {
          dotsWrap.addEventListener('click', function (e) {
            var dot = e.target.closest('[data-amc-dot]');
            if (!dot) return;
            var i = parseInt(dot.getAttribute('data-amc-dot'), 10);
            if (isNaN(i)) return;
            var list = slides();
            scrollToSlide(track, list, i);
            updateDots(root, i);
          });
        }
      });
    }

    function boot(scope) {
      initGifVideos(scope);
      initMmmCarouselNav(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multislider-mosaic-mobile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGifVideos(scope) {
      (scope || document).querySelectorAll('.section-multislider-mosaic-mobile [data-mmc-video-gif]').forEach(function (wrap) {
        if (wrap.dataset.mmcGifInit === '1') return;
        wrap.dataset.mmcGifInit = '1';
        var video = wrap.querySelector('video');
        var btn = wrap.querySelector('[data-mmc-play-btn]');
        if (!video) return;
        if (btn) btn.setAttribute('aria-pressed', 'false');
        function setPlaying(playing) {
          wrap.classList.toggle('is-playing', playing);
          if (btn) btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        }
        function togglePlay() {
          if (video.paused) {
            video.muted = true;
            video.play().then(function () { setPlaying(true); }).catch(function () {
              setPlaying(false);
            });
          } else {
            video.pause();
            setPlaying(false);
          }
        }
        wrap.addEventListener('click', function (e) {
          if (e.target.closest('[data-mmc-play-btn]') || !wrap.classList.contains('is-playing')) {
            e.preventDefault();
            togglePlay();
          }
        });
        video.addEventListener('ended', function () {
          if (video.loop) return;
          setPlaying(false);
        });
        video.addEventListener('pause', function () {
          if (!video.ended) setPlaying(false);
        });
      });
    }

    function boot(scope) {
      initGifVideos(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
